import { ArrowRight, MailWarning } from "lucide-react";
import { ProductStatus } from "@/components/ProductStatus";
import { useModalFocus } from "@/lib/useModalFocus";

export const OrderEmailRequiredDialog = ({ mode, reason, message, onCancel, onConfigure, returnFocusRef }) => {
  const { dialogRef, onKeyDown } = useModalFocus(onCancel, false, returnFocusRef);
  return (
    <div ref={dialogRef} onKeyDown={onKeyDown} tabIndex={-1}
         className="workflow-ux fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4"
         role="dialog" aria-modal="true" aria-labelledby="order-email-required-title"
         data-testid="order-email-required-modal">
      <div className="w-full max-w-md bg-white border border-[#E5E5E0] shadow-xl p-6 sm:p-8">
        <ProductStatus tone="warning" icon={MailWarning} testId="order-email-required-status">Da configurare</ProductStatus>
        <h2 id="order-email-required-title" className="font-serif text-xl mt-5 mb-3" data-testid="order-email-required-title">
          {reason === "ORDER_EMAIL_INVALID" ? "Email ordini da correggere" : "Email ordini mancante"}
        </h2>
        <p className="text-sm leading-relaxed text-[#525252]" data-testid="order-email-required-message">
          {message || "Prima di inviare l’ordine al fornitore, inserisci l’email ordini nell’anagrafica account. Sarà usata per le risposte, nel testo e nel PDF."}
        </p>
        {mode === "form" && <p className="text-xs text-[#707070] mt-3" data-testid="order-email-required-draft-note">
          Se hai modifiche non salvate, potrai conservarle come bozza prima di andare all’anagrafica.
        </p>}
        <div className="flex flex-wrap justify-end gap-3 mt-7">
          <button type="button" className="btn-ghost" onClick={onCancel} data-testid="order-email-required-cancel">
            Resta nell’ordine
          </button>
          <button type="button" className="btn-primary inline-flex items-center gap-2" onClick={onConfigure}
                  data-testid="order-email-required-go-profile">
            Configura email ordini <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};